import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import authAPI from '../actions/authAPI';

const initialState = {
  value: 0,
  status: 'idle',
  loading: false,
  userDetail: {}
};
export const incrementAsync = createAsyncThunk(
  'counter/fetchCount',
  async (amount) => {
    const response = amount;
    return response.data;
  }
);

export const getMemberDetail = createAsyncThunk(
  'auth/getMemberDetail',
  async (params, thunkAPI) => {
    const response = await authAPI.getMemberDetail(params)
    return response.data
  }
);
export const userLogInSlice = createSlice({
  name: 'userLogIn',
  initialState,
  reducers: {
    login: (state) => {
      state.value += 1;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMemberDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMemberDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.userDetail = action.payload;
      });
  },
});

export const { login } = userLogInSlice.actions;
export const selectCount = (state) => state.login.value;

export default userLogInSlice.reducer;
